const LOCATION_GATE_RETRY_KEY = "location-gate-retry:v1";

export function markLocationGateRetryPending(): void {
  try {
    sessionStorage.setItem(LOCATION_GATE_RETRY_KEY, "1");
  } catch {
    // ignore
  }
}

export function consumeLocationGateRetryPending(): boolean {
  try {
    if (sessionStorage.getItem(LOCATION_GATE_RETRY_KEY) !== "1") {
      return false;
    }
    sessionStorage.removeItem(LOCATION_GATE_RETRY_KEY);
    return true;
  } catch {
    return false;
  }
}
